var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchAlterar, fetchResource, fetchConsultarPaginada } from '../../../api';
var ROTA_BASE = 'reeducandos-pontos';
/**
 * Busca a listagem de registros diários de ponto para validação (fiscal local web).
 * GET /reeducandos-pontos/validation?source=web
 *
 * @param pagination - Modelo de paginação (página e quantidade por página)
 * @param filtros - Filtros opcionais: nome, codigo_colaborador, instituicao_id, data_inicio, data_fim
 * @returns Promessa com a lista de registros de ponto e o total de registros
 */
export var getColaboradores = function (pagination, filtros) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/validation?source=web");
                if (filtros === null || filtros === void 0 ? void 0 : filtros.nome)
                    url += "&nome=".concat(encodeURIComponent(filtros.nome));
                if (filtros === null || filtros === void 0 ? void 0 : filtros.codigo_colaborador)
                    url += "&matricula=".concat(encodeURIComponent(filtros.codigo_colaborador));
                if (filtros === null || filtros === void 0 ? void 0 : filtros.contrato_id)
                    url += "&contrato_id=".concat(filtros.contrato_id);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.instituicao_id)
                    url += "&instituicao_id=".concat(filtros.instituicao_id);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.status)
                    url += "&status=".concat(encodeURIComponent(filtros.status));
                if (filtros === null || filtros === void 0 ? void 0 : filtros.data_inicio)
                    url += "&data_inicio=".concat(filtros.data_inicio);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.data_fim)
                    url += "&data_fim=".concat(filtros.data_fim);
                return [4 /*yield*/, fetchConsultarPaginada(url, pagination)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getReeducandos = getColaboradores;
/**
 * Busca o histórico de batidas de ponto de um reeducando (fiscal local web).
 * GET /reeducandos-pontos/reeducando/:id?source=web
 *
 * @param reeducandoId - ID do reeducando
 * @param dataInicio - Data de início do período no formato YYYY-MM-DD (opcional)
 * @param dataFim - Data de fim do período no formato YYYY-MM-DD (opcional)
 * @returns Promessa com o histórico de batidas
 */
export var getHistoricoReeducando = function (reeducandoId, dataInicio, dataFim) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/reeducando/").concat(reeducandoId, "?source=web");
                if (dataInicio && dataFim) {
                    url += "&data_inicio=".concat(dataInicio, "&data_fim=").concat(dataFim);
                }
                return [4 /*yield*/, fetchResource(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Busca o detalhe de validação do dia com evidências de auditoria.
 * GET /reeducandos-pontos/validation/:id?source=web
 */
export var getDetalheValidacaoDia = function (pontoId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchResource("".concat(ROTA_BASE, "/validation/").concat(pontoId, "?source=web"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Busca os contratos vinculados ao fiscal no escopo de validação diária.
 * GET /reeducandos-pontos/contracts?source=web
 *
 * @returns Promessa com a lista de contratos
 */
export var getContratos = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchResource("".concat(ROTA_BASE, "/contracts?source=web"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Aprova o bate-ponto do dia.
 * PATCH /reeducandos-pontos/:id/aprovar?source=web
 *
 * @param id ID do registro diário de ponto
 * @param observacao Observação opcional (máximo 500 caracteres)
 */
export var aprovarPonto = function (id, observacao) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(id, "/aprovar?source=web");
                return [4 /*yield*/, fetchAlterar(url, { observacao: observacao })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Aprova o dia do colaborador quando ainda não existe registro diário persistido.
 * PATCH /reeducandos-pontos/reeducando/:id/data/:data/aprovar?source=web
 */
export var aprovarPontoPorData = function (reeducandoId, data, observacao) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/reeducando/").concat(reeducandoId, "/data/").concat(data, "/aprovar?source=web");
                return [4 /*yield*/, fetchAlterar(url, { observacao: observacao })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Reprova o bate-ponto do dia.
 * PATCH /reeducandos-pontos/:id/reprovar?source=web
 *
 * @param id ID do registro diário de ponto
 * @param motivo Motivo obrigatório da reprovação (máximo 200 caracteres)
 */
export var reprovarPonto = function (id, motivo) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(id, "/reprovar?source=web");
                return [4 /*yield*/, fetchAlterar(url, { motivo: motivo })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Reprova o dia do colaborador quando ainda não existe registro diário persistido.
 * PATCH /reeducandos-pontos/reeducando/:id/data/:data/reprovar?source=web
 */
export var reprovarPontoPorData = function (reeducandoId, data, motivo) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/reeducando/").concat(reeducandoId, "/data/").concat(data, "/reprovar?source=web");
                return [4 /*yield*/, fetchAlterar(url, { motivo: motivo })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
